import React from 'react';

import { useRouter } from 'next/router';

import FormSteps from '@/components/FormSteps';
import StickyPhoneBubble from '@/components/StickyPhoneBubble';

import { BsFillCheckCircleFill } from 'react-icons/bs';

const RoofWorkType = ({ category = {} }) => {
  const [details, setDetails] = React.useState();

  const [error, setError] = React.useState(false);

  const router = useRouter();

  React.useEffect(() => {
    if (window.innerWidth <= 480 && details) {
      if (details === 'New Roof') {
        router.push(`/cf/${category.url_slug}/new`);
      } else {
        router.push(`/cf/${category.url_slug}/repair`);
      }
    }
  }, [details]);

  const handleInputChange = (details) => {
    setError(false);
    setDetails(details);
  };

  const validate = () => {
    setError(false);

    if (!details) {
      setError(true);
    } else {
      if (details === 'New Roof') {
        router.push(`/cf/${category.url_slug}/new`);
      } else {
        router.push(`/cf/${category.url_slug}/repair`);
      }
    }
  };

  return (
    <div className="sms-lead-form-container">
      <div className="sms-form-wrapper">
        <FormSteps stepIndex={1} totalSteps={8} />
        <h1>Tell us what type of project this is.</h1>
        <fieldset className="panel-content">
          <div className="row">
            <div className={`input-container radio-container ${error ? 'error' : ''} ${details ? 'hasValue' : ''}`}>
              <button className={`radio button ${details === 'New Roof' ? 'selected' : ''}`} onClick={() => handleInputChange('New Roof')}>
                {details === 'New Roof' && <BsFillCheckCircleFill />}
                New Roof
              </button>
              <button className={`radio button ${details === 'Repair' ? 'selected' : ''}`} onClick={() => handleInputChange('Repair')}>
                {details === 'Repair' && <BsFillCheckCircleFill />}
                Repair
              </button>
            </div>
          </div>
          <div className="error_msg">{error ? 'Please select a project type.' : <span>&nbsp;</span>}</div>
          <div className="row next-container">
            <div className="actions">
              <button className="next button" onClick={validate}>
                Next
              </button>
            </div>
          </div>
        </fieldset>
      </div>
      <StickyPhoneBubble category={category} />
    </div>
  );
};

export default RoofWorkType;
